import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Оновлено:',
  breadcrumbs: {
    home: 'Головна',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Чому нам можна довіряти',
        details: {
          text: `<h2>Чому нам можна довіряти</h2><p>Статті на Natu.Care написані на основі наукових досліджень, даних з урядових сайтів та інших надійних джерел. Тексти написані у співпраці з лікарями, дієтологами та іншими експертами в галузі здоров'я та краси. Статті переглядаються перед публікацією та під час значних оновлень.</p>.`,
          footerText: '<p>Дізнайтеся більше про наші <a href="/ua/pro-nas/editorial-process">редакційний процес</a></p>.'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Інформація про рекламні оголошення',
        details: {
          text: `<h2>Інформація про рекламу</h2><p>Контент на Natu.Care може містити посилання на продукти, від продажу яких ми можемо отримувати комісійні. При створенні контенту ми дотримуємося високих редакційних стандартів і намагаємося бути об'єктивними щодо обговорюваних продуктів. Наявність партнерських посилань не продиктована нашими партнерами, і ми обираємо продукти, які розглядаємо, абсолютно самостійно.</p>.`,
          footerText: '<p>Дізнайтеся більше про наші <a href="/ua/pravylae">Умови та положення</a></p>.',
        }
      }
    ],
    tooltip: {
      labelVerified: 'Перевірено експертом',
      footerText: '<p>Дізнайтеся більше про наші <a href="/ua/pro-nas/editorial-process">редакційний процес</a></p>.'
    }
  },

  mediabar: {
    heading: 'ЗМІ про нас:',
    href: '/ua/pro-nas',
    title: 'ЗМІ про нас:',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Подбайте про здорове тіло',
    description: `Спробуйте високоякісні добавки Natu.Care`,
    button: {label: 'Переглянути продукти', href: 'https://natu.shop/collections'},
    picture: {alt: 'Молоді, красиві жінки з гарним станом шкіри'}
  },

  authorship: {
    heading: 'Редакційні статті',
    link: {
      label: 'Познайомтеся з командою',
      href: '/ua/pro-nas/redaktsiya'
    }
  },

  similarArticles: {
    headingBlogList: 'Статті',
    headingBlogPost: 'Схожі статті'
  }  
};
